import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import { IconButton, Stack, Typography } from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";
import NewTransaction from "./NewTransaction";
import "./styles.scss";
import { useEffect, useState } from "react";
import CustomSnackbar from "../common/Snackbar/CustomSnackbar";
import { generateClientName, toggleDrawer } from "../../utils/utils";
import NewButton from "../common/NewButton/NewButton";
import {
  resetSelectedTransaction,
  setSelectedTransaction,
} from "../../redux/features/transactionsSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  getClients,
  getTransactionsById,
} from "../../services/transactionService";
import { RootState } from "../../redux/store";
import { TransactionDataType } from "../../types/genericType";
import { DropdownOptions } from "../common/Dropdown/Dropdown";

type TransactionDrawerProps = {
  openEditDrawer: boolean;
  setOpenEditDrawer: Function;
  getAllTransactions: Function;
  transactionResponse: TransactionDataType[];
};

const TransactionDrawer = (props: TransactionDrawerProps) => {
  const {
    openEditDrawer,
    setOpenEditDrawer,
    getAllTransactions,
    transactionResponse,
  } = props;
  const [open, setOpen] = useState(false);
  const [editFlow, setEditFlow] = useState(false);
  const [clientOptions, setClientOptions] = useState<DropdownOptions[]>([]);

  const [onSuccess, setOnSuccess] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const dispatch = useDispatch();

  const { selectedTransaction } = useSelector(
    (state: RootState) => state.transactionDetailsState
  );

  const handleDrawerOpen = toggleDrawer<React.KeyboardEvent | React.MouseEvent>(
    true,
    setOpen
  );
  const handleDrawerClose = () => {
    setEditFlow(false);
    setOpen(false);
    setOpenEditDrawer(false);
  };

  const getClientOptions = async () => {
    getClients()
      ?.then((res) => {
        const clients: DropdownOptions[] = [];
        res.forEach((client: any) => {
          if (editFlow || client.isActive) {
            clients.push({
              value: client.id,
              label: generateClientName(client),
            });
          }
        });
        setClientOptions(clients);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getClientOptions();
  }, []);

  useEffect(() => {
    if (openEditDrawer) {
      setEditFlow(true);
      setOpen(openEditDrawer);
    }
  }, [openEditDrawer]);

  useEffect(() => {
    if (!editFlow) {
      dispatch(resetSelectedTransaction());
    } else {
      selectedTransaction &&
        getTransactionsById(selectedTransaction.id)
          .then((res) => {
            const updatedTransaction = { ...selectedTransaction, ...res };
            dispatch(setSelectedTransaction(updatedTransaction));
          })
          .catch((err) => {
            console.log(err);
          });
    }
  }, [editFlow]);

  const drawerComp = (
    <Stack>
      <Box className="drawer-header" role="presentation">
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          fontWeight={700}
        >
          {editFlow ? "Edit Transaction" : "New Transaction"}
        </Typography>
        <IconButton
          aria-label="toggle password visibility"
          onClick={handleDrawerClose}
          size="large"
        >
          <CloseOutlined />
        </IconButton>
      </Box>
      <NewTransaction
        setDrawerOpen={setOpen}
        clientOptions={clientOptions}
        setOnTxnSuccess={setOnSuccess}
        setSnackbarMsg={setSnackbarMsg}
        editFlow={editFlow}
        selectedTransaction={selectedTransaction ?? null}
        handleDrawerClose={handleDrawerClose}
        getAllTransactions={getAllTransactions}
        transactionResponse={transactionResponse}
      />
    </Stack>
  );

  return (
    <div className="transaction-drawer">
      <React.Fragment>
        <NewButton
          title={"NEW TRANSACTION"}
          handleBtnClick={handleDrawerOpen}
          type="contained"
        />
        <Drawer
          anchor="right"
          variant="temporary"
          open={open}
          sx={{
            display: { xs: "none", sm: "block" },
            "&.MuiDrawer-root .MuiDrawer-paper": {
              marginTop: "65px",
              width: "436px",
            },
          }}
        >
          {drawerComp}
        </Drawer>
        <CustomSnackbar
          open={onSuccess}
          message={snackbarMsg}
          setOpen={setOnSuccess}
        />
      </React.Fragment>
    </div>
  );
};

export default TransactionDrawer;
